export const FETCH_SCHOOLS_REQUEST = 'schools/FETCH_SCHOOLS_REQUEST';
export const FETCH_SCHOOLS_SUCCESS = 'schools/FETCH_SCHOOLS_SUCCESS';
export const FETCH_SCHOOLS_FAILURE = 'schools/FETCH_SCHOOLS_FAILURE';

export const INIT_SCHOOLS = 'schools/INIT_SCHOOLS';

export const fetchSchoolsRequest = (payload = {}) => ({
  type: FETCH_SCHOOLS_REQUEST,
  payload,
});
export const fetchSchoolsSuccess = (payload = {}) => ({
  type: FETCH_SCHOOLS_SUCCESS,
  payload,
});
export const fetchSchoolsFailure = (payload = {}) => ({
  type: FETCH_SCHOOLS_FAILURE,
  payload,
});

export const initSchools = (payload = {}) => ({
  type: INIT_SCHOOLS,
  payload,
});
